import {FC, useEffect, useState} from 'react';

export type InteractionLoadableProps = {
    keepRendered?: boolean;
    show?: boolean;
};

export const InteractionLoadable: FC<InteractionLoadableProps> = ({children, keepRendered = false, show = false}) => {
    const [wasRendered, setRendered] = useState<boolean>(false);

    useEffect(() => {
        if (!wasRendered && show) {
            setRendered(true);
        }
    }, [show, wasRendered]);

    const render = show || (keepRendered && wasRendered);

    return <>{render && children}</>;
};
